// removed by extract-text-webpack-plugin
module.exports = {"OptionButton":"_2dQHC-S82s7KmWQ3RX5yUb","onlineCoworkerImg":"_19pKPk_VCIAyNDEHI84lUr","transferCoworkerItem":"_3vfmNNN6vQvaodoE5c96NY","SendButton":"_2YsDQQGLKx1fuRHOLp0Aij","menuText":"_1iVi2A604aM8WtyKBBXElt","buttonImg":"kfu0HRLszLEQISZc8Ewsv","Option":"_LYV-r4XvE6HJOYvSvZEd","TicketPanel":"_3Yk2Gp5p5yZHFKJv__-4uf","TicketPrevious":"_10Z0kIQdRI0KLIt4KMnErn","TicketFirstEntry":"_65kOZmeAu2XOmGpGGj3tO","TicketInfoSaveButton":"_2PP8NI_uxmYBzH4gUePRzk","BodyText":"KHiN3qOCPQpmgp5ABethu"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/Conversation/Assigned/index.css
// module id = 941
// module chunks = 0